import { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Services } from "@/components/Services";
import { BabyFund } from "@/components/BabyFund";
import { CoreValues } from "@/components/CoreValues";
import { Manifesto } from "@/components/Manifesto";
import { Founder } from "@/components/Founder";
import { Estimator } from "@/components/Estimator";
import { JoinTeam } from "@/components/JoinTeam";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { BookingManage } from "@/components/BookingManage";
import { OwnerPage } from "@/components/OwnerPage";

const Home = () => (
  <div className="grain min-h-screen bg-obsidian text-white" data-testid="app-shell">
    <Navbar />
    <main>
      <Hero />
      <Marquee />
      <Services />
      <BabyFund />
      <CoreValues />
      <Manifesto />
      <Founder />
      <Estimator />
      <JoinTeam />
      <Contact />
    </main>
    <Footer />
  </div>
);

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.25, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <BrowserRouter>
      <Toaster position="top-center" theme="dark" richColors />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/booking/:token" element={<BookingManage />} />
        <Route path="/owner" element={<OwnerPage />} />
      </Routes>
    </BrowserRouter>
  );
}
